import { render, staticRenderFns } from "./go_to_top.vue?vue&type=template&id=289a0d6e&lang=pug"
import script from "./go_to_top.vue?vue&type=script&lang=js"
export * from "./go_to_top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports